module.exports = __webpack_public_path__ + "static/media/secao-3-bg.948a772e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/secao-3-bg.jpg
// module id = 939
// module chunks = 7